'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconPotWithLid, iconPotWithLidTag } from '@ni/nimble-components/dist/esm/icons/pot-with-lid';
import { wrap } from '../../utilities/react-wrapper';

export type { IconPotWithLid };
export { iconPotWithLidTag };
export const NimbleIconPotWithLid = wrap(IconPotWithLid);